import { Observable } from 'rxjs';

export function loadScript(src: string): Observable<void> {
    return new Observable<void>(sub => {
        let script: any = document.createElement('script');
        let loaded = false;
        script.setAttribute('src', src);

        script.onreadystatechange = script.onload = function () {
            if (!loaded) {
                sub.next();
                sub.complete();
            }
            loaded = true;
        }
        document.getElementsByTagName('head')[0].appendChild(script);
    });
}
